import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { analytics } from 'analytics';
import { signOutUser } from 'redux/slices/user.slice';
import baseApi from 'services/api/baseApi';
import { unregisterFcmOnLogout } from 'services/fcmTokenStore';

import { AppDispatch } from '../../../../redux/store';
import firebaseCleanup from '../../../../redux/thunks/firebaseCleanup';
import { useLogoutUserMutation } from '../../../../services/api/user.api';

const useSidebarActions = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [logoutUser] = useLogoutUserMutation();

  const handleSignOut = useCallback(() => {
    analytics.captureUserLoggedOut({ trigger: 'manual' });
    unregisterFcmOnLogout().catch(() => {});
    logoutUser()
      .unwrap()
      .catch(() => {});
    analytics.reset();
    dispatch(firebaseCleanup());
    dispatch(baseApi.util.resetApiState());
    dispatch(signOutUser());
    navigate('/sign-in');
  }, [dispatch, logoutUser, navigate]);

  return { handleSignOut };
};

export default useSidebarActions;
